import React, { useEffect, useState } from 'react';
import Column from '@amzn/meridian/column';
import { useDeviceLayout } from '../common/context/DeviceLayoutContext';
import { getFeaturesFromParent } from '../handler/ParentDataHandler';
import AssociateFilter from './AssociateFilter';
import AssociatePerformance from './AssociatePerformance';
import AssociateScanChartView from './AssociateScanChartView';

const IS_ASSOCIATE_SCAN_METRIC_ENABLED = 'IS_ASSOCIATE_SCAN_METRIC_ENABLED';

/**
 * Associate — feature entry (React + Meridian, ported from v1 Associate.js).
 * Resolves the scan-metric feature flag, then either mounts the scan-chart view (flag on) or
 * the filter + performance table (flag off). Owns the shared active-state filter (`states`) and
 * wires AssociateFilter (onChange) -> AssociatePerformance (states) — the composer owns the
 * cross-screen shared state (generate-code Rule 10; was AssociateFilterContext in v1).
 */
const Associate: React.FC = () => {
  const { spacingInset_shorthand2 } = useDeviceLayout();
  const [isEnabled, setIsEnabled] = useState<boolean | null>(null);
  const [states, setStates] = useState<string[]>([]);

  useEffect(() => {
    getFeaturesFromParent<Record<string, boolean>>([IS_ASSOCIATE_SCAN_METRIC_ENABLED])
      .then((res) => setIsEnabled(res?.data?.isAssociateScanMetricEnabled || false))
      .catch(() => setIsEnabled(false));
  }, []);

  const header = (
    <header>
      <h2>Induct associates</h2>
      <p>This page shows induct associates’ performance data and current working location</p>
    </header>
  );

  if (isEnabled === null) {
    return (
      <Column spacing="medium" spacingInset={spacingInset_shorthand2}>
        {header}
      </Column>
    );
  }

  return (
    <Column spacing="medium" spacingInset={spacingInset_shorthand2}>
      {header}
      {isEnabled ? (
        <AssociateScanChartView />
      ) : (
        <React.Fragment>
          <AssociateFilter states={states} onChange={setStates} />
          <AssociatePerformance states={states} />
        </React.Fragment>
      )}
    </Column>
  );
};

export default Associate;
